// ─── EXAMPLES LIBRARY CLIENT (Phase 1) ────────────────────────────────────
// GET /api/v1/examples       — list (full BriefEnvelope inlined per item)
// GET /api/v1/examples/{id}  — detail (output: null in Phase 1)
//
// Tenant is REQUIRED on both calls. The contract states tenant is read from
// JWT claims, but when the JWT carries multiple tenants the BE picks one
// (alphabetical) and silently mismatches the id prefix → 403 on detail and
// the wrong list on list. Always send ?tenant=<active>.

import { API_V1, getAuthHeaders, getSessionHeaders } from './config.js';

async function readError(res) {
  const err = await res.json().catch(() => ({}));
  const ref = err.request_id ? ` (ref: ${err.request_id})` : '';
  return new Error((err.message || `Examples request failed: ${res.status}`) + ref);
}

export async function fetchExamples({ tenant, contentFormat }) {
  if (!tenant) throw new Error('fetchExamples: tenant is required');
  const qs = new URLSearchParams({ tenant });
  if (contentFormat) qs.set('content_format', contentFormat);

  const res = await fetch(`${API_V1}/examples?${qs}`, {
    headers: { ...getSessionHeaders(), ...getAuthHeaders() },
  });
  if (!res.ok) throw await readError(res);
  return res.json(); // { examples: ExampleListItem[] }
}

export async function fetchExampleDetail(id, { tenant }) {
  if (!tenant) throw new Error('fetchExampleDetail: tenant is required');
  const qs = new URLSearchParams({ tenant });

  const res = await fetch(`${API_V1}/examples/${encodeURIComponent(id)}?${qs}`, {
    headers: { ...getSessionHeaders(), ...getAuthHeaders() },
  });
  if (!res.ok) throw await readError(res);
  return res.json(); // { id, metadata, brief, output: null }
}
